module.exports = __webpack_public_path__ + "files/SPIADI2024 - Rapport national surveillance - janvier 2026.062f8466b9e337db8cd62de55f5fb8d6.pdf";